import React from "react";
import PropTypes from "prop-types";
import { TaskSheet } from "./TaskSheet";
import { useMyWorkByDateTaskNavigation } from "../../Hooks";

export const MyWorkByDateNavigation = React.forwardRef(({ taskId, userId, ...props }, ref) => {
  const [prev, next] = useMyWorkByDateTaskNavigation(taskId, userId);
  return (
    <TaskSheet
      ref={ref}
      taskId={taskId}
      prev={prev}
      next={next}
      {...props}
    />
  );
});

MyWorkByDateNavigation.propTypes = {
  taskId: PropTypes.number,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
};

MyWorkByDateNavigation.displayName = "MyWorkByDateNavigation";
